import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../styles/global.css";
import React, { useEffect, useState } from "react";
import { Analytics } from "@biocentury/core";
import { Product } from "@biocentury/core/types";
import PageContainer from "@components/page-container";
import AuthContext, { AuthDispatchContext } from "@contexts/auth-context";
import { queryClient } from "@queries/query-client";
import { getCurrentUser } from "@utils/services/auth";
import { useRouter } from "next/router";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Hydrate } from "react-query/hydration";
import smoothscroll from "smoothscroll-polyfill";
if ("object" !== "undefined") {
    smoothscroll.polyfill();
}
var App = function(props) {
    var pageProps = props.pageProps;
    var router = useRouter();
    var ref = useState(getCurrentUser), currentUser = ref[0], setCurrentUser = ref[1];
    var pageView = function() {
        var page = pageProps.page;
        var event = {
            name: "pageview",
            action: "pageview",
            path: page && page.path,
            category: page && page.path,
            product: Product.Profiles
        };
        Analytics.SegmentAnalytics.page();
        Analytics.WebUsage.track(event);
    };
    useEffect(function() {
        pageView();
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ _jsx(AuthContext.Provider, {
        value: currentUser,
        children: /*#__PURE__*/ _jsx(AuthDispatchContext.Provider, {
            value: setCurrentUser,
            children: /*#__PURE__*/ _jsx(QueryClientProvider, {
                client: queryClient,
                children: /*#__PURE__*/ _jsxs(Hydrate, {
                    state: pageProps.dehydratedState,
                    children: [
                        /*#__PURE__*/ _jsx(PageContainer, _object_spread({}, props)),
                        /*#__PURE__*/ _jsx(ReactQueryDevtools, {
                            initialIsOpen: false
                        })
                    ]
                })
            })
        })
    });
};
export default App;
